




































































































import Vue from 'vue'
import MyPatientsDataTable from '@/components/patients/MyPatientsDataTable.vue'
import MyPatientsFilterFunctions from '@/components/patients/MyPatientsFilterFunctions.vue'
import SiteStatsCard, { SiteStatsCardType } from '@/components/exec-dashboard/SiteStatsCard.vue'
import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import {
  ActionNames as SiteStatsActionNames,
  GetterNames as SiteStatsGetterNames,
} from '@/store/modules/site-stats/keys'
import {
  ActionNames as SiteReadingsActionNames,
  GetterNames as SiteReadingsGetterNames,
} from '@/store/modules/site-readings/keys'
import { getCsvDownloadFunction } from '@/http/utils'
import { FlatSiteStats } from '@/store/modules/site-stats/getters'

import { ActionNames as PatientActionNames, GetterNames as PatientGetterNames } from '@/store/modules/patient/keys'
import { FlatPatient } from '@/store/modules/patient/getters'
import { getPatientName } from '@/utils/patients'
import { AppGetterNames } from '@/store/modules/app/keys'
import { OFFSET_HOURS_TIMESTAMP } from '@/components/patient-stats/graphs/mapping-chart-options/constants'
import moment from 'moment-timezone'
import SiteStatsFilterFunctions from '@/components/site-stats/SiteStatsFilterFunctions.vue'
import { SiteReadings } from '@/jsonapi/SiteReadings'
import { getSuccessRatePieChartOptions } from '@/components/site-stats/SuccessRatePieChartOptions'
import { buildSiteReadingTimelineChartOptions } from '@/components/site-stats/readings-line-chart-options'
import EditSiteStatsVariablesDialog from '@/components/dialog/EditSiteStatsVariablesDialog.vue'
import { ActionNames as SiteActionNames, GetterNames as SiteGetterNames } from '@/store/modules/site/keys'
import { GlucometerReadingCounts } from '@/jsonapi/SiteStats'
import { getErrorRateBarChartOptions } from '@/components/site-stats/ErrorRateBarChartOptions'

const patientFilterOptions = [
  { label: 'IN PROGRESS', value: 'active' },
  { label: 'COMPLETED', value: 'completed' },
  { label: 'ALL', value: '' },
]

type ComponentData = {
  isInitialLoading: boolean
  reloading: boolean
  downloadingTypes: string[]
  searchText: string
  patientFilterOptions: typeof patientFilterOptions
  selectedPatientFilter: typeof patientFilterOptions[0]
  selectedPeriod?: object
  glucometerSuccess?: number
  glucometerNoPid?: number
  glucometerInvalidPid?: number
  glucometerQC?: number
  showEditVariablesDialog: boolean
  loadedStartTimestamp?: number
  loadedSiteId?: string
  startTimestamp?: number
  endTimestamp?: number
}

type SiteStatsCardData = {
  siteStatses: [FlatSiteStats | null]
  type: string
  icon?: string
  iconLoading: boolean
  iconEvents?: {
    click: () => Promise<void>
  }
}

export default Vue.extend({
  components: {
    SiteStatsCard,
    MyPatientsDataTable,
    MyPatientsFilterFunctions,
    SiteStatsFilterFunctions,
    EditSiteStatsVariablesDialog,
  },
  data(): ComponentData {
    return {
      isInitialLoading: true,
      reloading: false,
      downloadingTypes: [],
      searchText: '',
      patientFilterOptions,
      selectedPatientFilter: patientFilterOptions[0],
      selectedPeriod: null,
      startTimestamp: null,
      endTimestamp: null,

      glucometerSuccess: null,
      glucometerNoPid: null,
      glucometerInvalidPid: null,
      glucometerQC: null,

      showEditVariablesDialog: false,
      loadedSiteId: null,
      loadedStartTimestamp: null,
    }
  },
  computed: {
    ...mapGetters(ModuleNames.site, {
      sites: `${SiteGetterNames.sites}`,
    }),
    ...mapGetters({
      siteStatses: `${ModuleNames.siteStats}/${SiteStatsGetterNames.siteStatses}`,
      [PatientGetterNames.patients]: `${ModuleNames.patient}/${PatientGetterNames.patients}`,
    }),
    // ...mapGetters(ModuleNames.siteReadings, [SiteReadingsGetterNames.siteReadings]),

    ...mapGetters(ModuleNames.app, {
      isAdminUser: AppGetterNames.isAdminUser,
    }),

    filteredPatients(): FlatPatient[] {
      const lowerCasedSearchText = this.searchText.toLowerCase()
      const currentSiteStats = this.currentSiteStatses[0]
      return this[PatientGetterNames.patients]
        .filter(patient => currentSiteStats.pids.includes(patient.id))
        .filter(patient => patient.status.includes(this.selectedFilter.value))
        .filter(patient => {
          const patientText = `${patient.phoneNumber} ${getPatientName(patient)}`.toLowerCase()
          return patientText.includes(lowerCasedSearchText)
        })
    },

    // disabled for performance (replaced with aggregate query)
    // currentSiteReadings(): [SiteReadings | null] {
    //   return (this[SiteReadingsGetterNames.siteReadings] || []).filter(r => r.id == this.siteStatsId)
    // },

    siteStatsId(): string {
      return this.$route.params.site_stats_id
    },
    currentSiteStatses(): [FlatSiteStats | null] {
      return [this.siteStatses.find(siteStats => siteStats.id === this.siteStatsId) || null]
    },
    currentSite(): object {
      let s = [this.sites.find(site => site.id === this.siteStatsId) || null]
      if (!s) return null
      return s[0]
    },
    currentSiteId(): string {
      return this.currentSiteStatses[0] ? this.currentSiteStatses[0].resourceId : ''
    },
    currentSiteName(): string {
      return this.currentSiteStatses[0] ? this.currentSiteStatses[0].siteName : ''
    },
    currentSiteStats(): object {
      return this.currentSiteStatses[0] ? this.currentSiteStatses[0] : null
    },
    siteStatsCardData(): SiteStatsCardData[] {
      return [
        {
          siteStatses: this.currentSiteStatses,
          type: SiteStatsCardType.interactions,
          icon: 'mdi-download',
          iconLoading: this.downloadingTypes.includes(SiteStatsCardType.interactions),
          iconEvents: {
            click: this.attachLoadingHandling({
              client: getCsvDownloadFunction({ path: `notes/${this.currentSiteName}` }),
              type: SiteStatsCardType.interactions,
            }),
          },
        },
        {
          siteStatses: this.currentSiteStatses,
          type: SiteStatsCardType.adherence,
          iconLoading: false,
        },
        {
          siteStatses: this.currentSiteStatses,
          type: SiteStatsCardType.recruitment,
          icon: 'mdi-download',
          iconLoading: this.downloadingTypes.includes(SiteStatsCardType.recruitment),
          iconEvents: {
            click: this.attachLoadingHandling({
              client: getCsvDownloadFunction({ path: `patients/${this.currentSiteName}` }),
              type: SiteStatsCardType.recruitment,
            }),
          },
        },
        {
          siteStatses: this.currentSiteStatses,
          type: SiteStatsCardType.events,
          icon: 'mdi-download',
          iconLoading: this.downloadingTypes.includes(SiteStatsCardType.events),
          iconEvents: {
            click: this.attachLoadingHandling({
              client: getCsvDownloadFunction({ path: `events/${this.currentSiteName}` }),
              type: SiteStatsCardType.events,
            }),
          },
        },
        this.isAdminUser
          ? {
              siteStatses: this.currentSiteStatses,
              type: SiteStatsCardType.vitals,
              icon: 'mdi-download',
              iconLoading: this.downloadingTypes.includes(SiteStatsCardType.vitals),
              iconEvents: {
                click: this.attachLoadingHandling({
                  client: getCsvDownloadFunction({ path: `observations/${this.currentSiteId}` }),
                  type: SiteStatsCardType.vitals,
                }),
              },
            }
          : null,
      ].filter(x => x)
    },
    hasReadings() {
      let readingCounts = this.currentSiteStats.siteUsageStats.glucometerReadingCountsPerMonthByType
      let readingCountsByMonth: GlucometerReadingCounts[] = Object.values(readingCounts || {})
      return readingCountsByMonth.some(counts => {
        return counts.totalCount > 0
      })
      // let readings = this.currentSiteReadings
      // let glucometerReadings = (readings && readings.length > 0 && readings[0].glucometerReadings) || []
      // return glucometerReadings.length > 0
    },
    qcReadings() {
      let readingCounts = this.currentSiteStats.siteUsageStats.glucometerReadingCountsPerMonthByType
      let readingCountsByMonth: GlucometerReadingCounts[] = Object.values(readingCounts || {})
      return readingCountsByMonth.some(counts => counts.qcCount > 0)
      // let readings = this.currentSiteReadings
      // let glucometerReadings = (readings && readings.length > 0 && readings[0].glucometerReadings) || []
      // return glucometerReadings.filter(
      //   r => r.matchedPatientId == null && r.devicePatientId && r.devicePatientId == 'QC'
      // ).length
    },
    successRateOptions() {
      console.log(`successRateOptions(): ${this.siteStatsId}`)

      let monthStart = moment(this.startTimestampCalculated)
        .startOf('month')
        .valueOf()
        .toString()

      let monthStr = moment(this.startTimestampCalculated).format('YYYYMM')
      let readingCounts = this.currentSiteStats.siteUsageStats.glucometerReadingCountsPerMonthByType
      let glucometerReadings = readingCounts[monthStr]

      let month =
        ' in ' +
        moment(this.startTimestampCalculated)
          .startOf('month')
          .format('MMM')

      return getSuccessRatePieChartOptions(glucometerReadings, month)
    },
    errorRateOptions() {
      let monthStr = moment(this.startTimestampCalculated).format('YYYYMM')
      let readingCounts = this.currentSiteStats.siteUsageStats.glucometerReadingCountsPerMonthByType
      let glucometerReadings = readingCounts[monthStr]
      let month =
        ' in ' +
        moment(this.startTimestampCalculated)
          .startOf('month')
          .format('MMM')
      return getErrorRateBarChartOptions(glucometerReadings, month)
    },
    readingTimelineOptions() {
      console.log(`readingTimelineOptions(): ${this.siteStatsId}`)
      let readingCounts = this.currentSiteStats.siteUsageStats.glucometerReadingCountsPerMonthByType
      return buildSiteReadingTimelineChartOptions({ readingsPerMonth: readingCounts, colors: [], chartWidth: 200 })
    },
    startTimestampCalculated() {
      // eslint-disable-next-line prettier/prettier
      return (
        this.startTimestamp ||
        moment()
          .startOf('month')
          .startOf('day')
          .valueOf()
      )
    },
  },
  async mounted(): Promise<void> {
    console.log('mounted()')
    const lastYearTimestamp = moment()
      .add(-1, 'y')
      .startOf('day')
      .valueOf()
    const startOfMonthTimestamp = moment()
      .startOf('month')
      .startOf('day')
      .valueOf()

    await this.downloadStats(startOfMonthTimestamp)
    this.isInitialLoading = false
  },
  async beforeUpdate(): Promise<void> {
    if (this.loadedSiteId != this.siteStatsId) {
      this.loadedSiteId = this.siteStatsId
      this.loadSiteStats({
        startTimestamp: this.startTimestamp,
        endTimestamp: this.endTimestamp,
      })
    }
    // const lastMonthTimestamp = moment()
    //   .subtract(1, 'months')
    //   .startOf('day')
    //   .valueOf()
    // await this.downloadStats(this.startTimestamp || lastMonthTimestamp)
  },
  methods: {
    ...mapActions(ModuleNames.patient, [PatientActionNames.getPatients]),
    ...mapActions(ModuleNames.site, [SiteActionNames.getSites]),
    ...mapActions(ModuleNames.siteStats, [SiteStatsActionNames.getSiteStatses]),
    // ...mapActions(ModuleNames.siteReadings, [SiteReadingsActionNames.getSiteReadingsById]),

    async downloadStats(startTimestamp): Promise<void> {
      console.log('downloadStats()::start')
      if (this.loadedSiteId === this.siteStatsId && this.loadedStartTimestamp === this.startTimestamp) {
        // already loaded. Skipping
        console.log('Already loaded. Skipping downloadStats()')
        return
      }

      this.reloading = true
      this.loadedSiteId = this.siteStatsId
      this.loadedStartTimestamp = this.startTimestamp
      await Promise.all([
        this[SiteActionNames.getSites](),
        this[SiteStatsActionNames.getSiteStatses](),
        // this[SiteReadingsActionNames.getSiteReadingsById]({
        //   siteId: this.siteStatsId,
        //   startTimestamp: startTimestamp,
        //   endTimestamp: moment().valueOf(),
        // }),
        this[PatientActionNames.getPatients](),
      ])
      this.reloading = false
      console.log('got grcpm by type: ')
      console.log(this.currentSiteStats.siteUsageStats.glucometerReadingCountsPerMonthByType)
      console.log('downloadStats()::end')
    },

    async loadSiteStats(payload: { startTimestamp: number; endTimestamp: number }): Promise<void> {
      const lastMonthTimestamp = moment()
        .subtract(1, 'months')
        .startOf('day')
        .valueOf()

      this.startTimestamp = payload.startTimestamp || lastMonthTimestamp
      this.endTimestamp = payload.endTimestamp || moment().valueOf()

      let self = this
      this.reloading = true
      const lastYearTimestamp = moment()
        .add(-1, 'y')
        .startOf('day')
        .valueOf()

      await this.downloadStats(this.startTimestamp)

      let siteStats = this[SiteStatsActionNames.getSiteStatses]({
        startTimestamp: Math.max(lastYearTimestamp, self.startTimestamp),
        endTimestamp: self.endTimestamp,
      })

      // let siteReadings = this[SiteReadingsActionNames.getSiteReadingsById]({
      //   siteId: this.siteStatsId,
      //   startTimestamp: Math.max(lastYearTimestamp, self.startTimestamp),
      //   endTimestamp: self.endTimestamp,
      // })
      await Promise.all([siteStats]).then(function() {
        self.reloading = false
      })
    },

    attachLoadingHandling(options: { client: () => Promise<void>; type: string }): () => Promise<void> {
      return async () => {
        this.downloadingTypes.push(options.type)
        await options.client()
        this.downloadingTypes = this.downloadingTypes.filter(fileType => fileType !== options.type)
      }
    },
    closeEditVariablesDialog() {
      this.showEditVariablesDialog = false
    },
    async afterSaveSiteVariables() {
      let self = this
      this.reloading = true
      await Promise.all([this[SiteActionNames.getSites](), this[SiteStatsActionNames.getSiteStatses]()])
      alert('Note: Cashflow data will be recalculated within 24 hours.')
      self.reloading = false
      this.showEditVariablesDialog = false
    },
  },
})
